import React, { useEffect, useRef } from "react";
import "./billing.less";
import {
  Modal,
  Form,
  Input,
  Button,
  Row,
  Col,
  DatePicker,
  Select,
  Typography,
  Spin,
} from "antd";
import { useDispatch } from "react-redux";
import moment from "moment";
import FormInput from "../../components/Input/FormInput";
import { useSelector } from "react-redux";
import {
  addSubpackagesInProgress,
  getSubPackagesListInProgress,
  updateSubpackagesInProgress,
} from "../../appRedux/doctor/actions/billingPackage";
import IntlMessages from "../../util/IntlMessages";

const { Option } = Select;

const SubPackageModel = ({
  isVisible,
  onCancel,
  onSubmit,
  selectedBillingId,
  type,
  setNavigate,
}) => {
  const formRef = useRef(null);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const organization_id = localStorage.getItem("org_id");

  React.useEffect(() => {
    form.setFieldsValue({
      package_name: type === "edit" ? selectedBillingId?.package_name : "",
      price: type === "edit" ? selectedBillingId?.price : "",
    });
  }, [selectedBillingId]);
  const { billingPaymentreducer } = useSelector((state) => state);
  const handleFinish = () => {
    formRef.current
      .validateFields()
      .then((values) => {
        const payload = {
          ...values,
          id: selectedBillingId?.id,
          handleSuccess: () => {
            const paylod = {
              organization_id: organization_id,
              pageNo: 1,
            };
            dispatch(getSubPackagesListInProgress({ paylod }));
            onCancel();
            form.setFieldsValue({
              package_name: "",
              price: "",
            });
          },
        };

        if (type === "edit") {
          dispatch(updateSubpackagesInProgress(payload));
        } else {
          dispatch(addSubpackagesInProgress(payload));
        }
      })
      .catch((errorInfo) => {
        console.log("Validation failed:", errorInfo);
      });
  };

  return (
    <Spin spinning={billingPaymentreducer?.addPayments?.inProgress === true}>
      <Modal
        title="ADD Package"
        visible={isVisible}
        width={800}
        onCancel={onCancel}
        footer={[
          <Button key="back" className="secondary-color" onClick={onCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={handleFinish}>
            Submit
          </Button>,
        ]}
        className={isVisible ? "slide-down" : ""}
      >
        <Form form={form} name="collectPaymentForm" ref={formRef}>
          <Row>
            <Col xs={24} sm={24} md={12} lg={11} xl={11}>
              {/* <Typography style={{ border: "2px solid black" }}>
                Package Name
              </Typography>
              <Form.Item
                name="package_name"
                rules={[
                  { required: true, message: "Please enter the package name" },
                ]}
              >
                <Input />
              </Form.Item>{" "} */}
              <FormInput
                labelCol={"24"}
                wrapperCol={"24"}
                type="text"
                name={"package_name"}
                label={"Package Name"}
                className={"input-alignment"}
                rules={[
                  { required: true, message: "Please enter the package name" },
                ]}
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={11} xl={11}>
              {/* <Typography>
                Amount<span className="star">*</span>
              </Typography>
              <Form.Item name="price">
                <FormInput type="number" name="price" />
              </Form.Item>{" "} */}
              <FormInput
                labelCol={"24"}
                wrapperCol={"24"}
                type="number"
                name={"price"}
                label={"price"}
                rules={[
                  {
                    required: true,
                    message: "Please enter the Amount",
                  },
                ]}
              />
            </Col>
          </Row>
        </Form>
      </Modal>
    </Spin>
  );
};

export default SubPackageModel;
